// extracted by mini-css-extract-plugin
export default {"userNotificationsHistory":"UserNotificationsHistoryPage_userNotificationsHistory__0tvdc"};